import actions from './actions';
import { createReducer } from '../../helpers/reducer';

const initState = {
  loading: false,
  contents: null,
  html: null,
};

function onLoadContentsRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadContentsSuccess(state, { payload }) {
  const { contents, html } = payload;

  return {
    ...state,
    contents,
    html,
    loading: false,
  };
}

export default createReducer(initState, {
  [actions.LOAD_CONTENTS_REQUEST]: onLoadContentsRequest,
  [actions.LOAD_CONTENTS_SUCCESS]: onLoadContentsSuccess,
});
